'use client';

import {
  Avatar,
  AvatarFallback,
  AvatarImage,
} from '@ahafood/ui/components/avatar';
import { assetPrefix } from '@ahm/api-wrappers-core';
import React from 'react';

interface HighlightItemsProps {
  items: any[];
}

const formatPrice = (price: number): string => {
  return new Intl.NumberFormat('vi-VN').format(price);
};

const HighlightItems: React.FC<HighlightItemsProps> = ({ items }) => {
  if (!items || items.length === 0) return null;

  return (
    <div
      role="presentation"
      className="mt-2 w-full overflow-x-auto scrollbar-hide"
      onClick={(e) => e.stopPropagation()}
      onKeyDown={(e) => e.stopPropagation()}
    >
      <div className="flex gap-3 pb-1">
        {items.map((item) => (
          <div
            key={item._id}
            className="flex w-24 md:w-40 flex-none flex-col gap-1.5"
          >
            <div className="relative aspect-square w-full overflow-hidden rounded-2xl bg-neutral-15">
              <Avatar className="size-full rounded-none">
                <AvatarImage
                  src={
                    item.image_preview_url && item.image_preview_url !== ''
                      ? item.image_preview_url
                      : item.image_thumb_url ||
                        `${assetPrefix}/static/images/empty-thumbnail.webp`
                  }
                  alt={item.name}
                  className="size-full object-cover"
                />
                <AvatarFallback className="size-full rounded-none">
                  {item.name ? item.name.charAt(0) : 'F'}
                </AvatarFallback>
              </Avatar>
            </div>
            <div className="flex items-baseline gap-1.5 flex-wrap">
              <span className="text-sm md:text-base font-bold text-neutral-90">
                đ{formatPrice(item.price)}
              </span>
              {item.original_price && item.original_price > item.price ? (
                <span className="text-[10px] text-neutral-50 line-through">
                  đ{formatPrice(item.original_price)}
                </span>
              ) : null}
            </div>
            <h4 className="line-clamp-2 text-xs md:text-sm font-medium text-neutral-70 leading-tight -mt-1">
              {item.name}
            </h4>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HighlightItems;
